import Navbar from "@/components/top-nav";
import React from "react";

export default  function AppLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <>
    
      <Navbar />
      {children}
    </>
  );
}
